import * as Normalize from '../normalize';
import * as Types from './types';

export const normalize = Normalize.normFn<Types.CustomRunColorsObjSchema>(
  'run-colors',
  whole => whole
);

export const denormalize = Normalize.denormFn<Types.CustomRunColorsObjSchema>(
  part => part
);
